// extracted by mini-css-extract-plugin
export default {"container":"ModalFooter_container__hpKtb"};